import { ChartSettingsInterface } from '@/tableBuilder/tableViewer/ChartSettings.molecule';
import { TableChartDataIF } from '@/tableBuilder/tableViewer/ChartUtilities';
import getColumnBarOptions from '@/tableBuilder/tableViewer/chartConfigs/columnAndBar';

const getColumnStackedOptions = (tableData: TableChartDataIF, settings: ChartSettingsInterface) =>
  getColumnBarOptions(tableData, { ...settings, stacked: true }, 'column');
export default getColumnStackedOptions;
